import { useSelector } from "react-redux";
import quiControleQuoiImage from "../../../assets/smartbuilding/userAndRoles/usersAndRole.png";
import map from "../../../assets/smartbuilding/userAndRoles/map.png";
import textContentSmarthomeContactUsSection from "../../smarthome/ui/textContent-smarthome-contactUsSection";

export default function UsersRolesSection(props) {
  const { textContent, language } = { ...props };
  const isMobile = useSelector((state) => state.screen.isMobile);
  const screenWidth = useSelector((state) => state.screen.screenWidth);

  return (
    <section className="container">
      <div className={`container-small ${isMobile ? "smart-mobile" : ""}`}>
        <h1 className="title-gradient">
          {textContent.userRolesSection.title[language]}
        </h1>
        <h2>{textContent.userRolesSection.subtitle[language]}</h2>
        <p>{textContent.userRolesSection.description[language]}</p>
      </div>
      <div className="users-and-roles-image-sb">
        <img
          src={isMobile ? quiControleQuoiImage : quiControleQuoiImage}
          aria-hidden="true"
        />
      </div>

      <div className={`users-and-roles-map-sb ${isMobile ? "mobile" : ""}`}>
        <div
          className={`users-and-roles-map-text-sb ${isMobile ? "mobile" : ""}`}
        >
          <h2 className="h2-bold">
            {textContent.userRolesSection.feature.multisite.title[language]}
          </h2>
          <p>
            {
              textContent.userRolesSection.feature.multisite.description[
                language
              ]
            }
          </p>

          <div className="container-empty-extra-small" />
          {!isMobile ? (
            <a
              href="https://www.polynhome.io/nous-contacter/"
              className="learn-more-button"
            >
              {
                textContentSmarthomeContactUsSection.contactUsSection.title[
                  language
                ]
              }
            </a>
          ) : null}
        </div>
        <div className="map-image-sb">
          <img src={map} aria-hidden="true" />
        </div>
      </div>
    </section>
  );
}
